const translations = {
	table: {
		columns: {
			raisonSociale: "Raison sociale",
			formeJuridique: "Forme juridique",
			montantTotalSouscriptions: "Montant total de souscriptions (€)",
			dateLastSubscription: "Date de la dernière souscription",
			nbProduitsSouscrits: "Nombre de produits souscrits",
		},
	},
};

export default translations;
